import { checkFeatureAndAuth } from '../utilities/FeatureDetection';
import { FeatureType } from '@apply/constants';

export interface ApplicationStylesProps {
    isFeatureDriven?: boolean;
    manualV2StylesOverride?: boolean;
    featureType?: FeatureType;
}

const v1Styles = () => {
    return (
        <>
            <link
                rel='stylesheet'
                href='/css/app.css'
            />
            <link
                rel='stylesheet'
                href='/css/accordion.css'
            />
            <link
                rel='stylesheet'
                href='/css/custom.css'
            />
            <link
                rel='stylesheet'
                href='/css/print.css'
            />
        </>
    );
};

export const ApplicationStyles: React.FC<ApplicationStylesProps> = ({
    isFeatureDriven,
    manualV2StylesOverride,
    featureType = FeatureType.ApplyV2,
}) => {
    if (!isFeatureDriven) {
        return v1Styles();
    } else {
        if (checkFeatureAndAuth(featureType) || manualV2StylesOverride) {
            import('@apply/components/src/scss/app.scss');
            <>
                <link
                    rel='stylesheet'
                    href='/css/accordion.css'
                />
                <link
                    rel='stylesheet'
                    href='/css/custom.css'
                />
                <link
                    rel='stylesheet'
                    href='/css/print.css'
                />
            </>;
            import('@apply/components/src/scss/applications/apply.scss');
        } else {
            return v1Styles();
        }
    }
};
